import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import VariableContext from "../contexts/VariableContext";
import FetchingFreq from "../contexts/FetchingFreq";
import config from "../configs/config";
import CustomizedVariable from "./CustomizedVariable";
import "./styles/Weighting.css";
import Loader from "./Loader";

function Weighting() {
  const navigate = useNavigate();
  const {
    dataGroup,
    setdataGroup,
    projectId,
    savedWeightings,
    saveCurrentWeighting,
    currentSelectedVariablesset,
    setcurrentSelectedVariablesset,
    setSavedWeightings,
    weightedCounts,
    weightingStats,
    setWeightingStats,
    setWeightedCounts,
    targetPercentages,
    setTargetPercentages,
    currentSelectedVariables,
    setCurrentSelectedVariables,
    frequencyData,
    setFrequencyData,selectedProject,selectedClient,powner
  } = useContext(VariableContext);

  const { handleTitleClick, setActivePage, loading, setLoading } =
    useContext(FetchingFreq);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [percentageWarnings, setPercentageWarnings] = useState({});
  
  // Add filter state
  const [filterExpression, setFilterExpression] = useState("");
  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    setActivePage("Weighting");
  }, []);

  // Add this function to validate percentages
  const validatePercentages = () => {
    const warnings = {};
    
    Object.entries(targetPercentages).forEach(([variable, targets]) => {
      if (targets && Object.keys(targets).length > 0) {
        const total = Object.values(targets).reduce((sum, val) => {
          const num = parseFloat(val) || 0;
          return sum + val;
        }, 0);
        
        const isValid = Math.abs(total - 100) < 0.01;
        if (!isValid) {
          warnings[variable] = {
            total: total,
            isValid: false
          };
        }
      }
    });
    
    setPercentageWarnings(warnings);
    return warnings;
  };

  useEffect(() => {
    if (Object.keys(targetPercentages).length > 0) {
      validatePercentages();
    }
  }, [targetPercentages]);

  const saveCurrentWeightingBackend = async () => {
    setLoading(true);
    try {
      const weightingData = {
        project_id: projectId,
        savedWeightings: savedWeightings,
      };

      const response = await axios.post(
        `${config.API_BASE_URL}/saveweightings/${projectId}`,
        weightingData
      );

      if (response.status === 200) {
        setLoading(false);
        alert("Weightings saved successfully!");
      } else {
        console.error("Failed to save weightings:", response.data);
        setLoading(false);
        alert("Failed to save weightings.");
      }
    } catch (error) {
      console.error("Error occurred while saving weightings:", error);
      setLoading(false);
      alert("Error occurred while saving weightings.");
    }
  };

  const loadWeightingData = (selectedWeighting) => {
    if (selectedWeighting) {
      setFrequencyData({});
      setWeightedCounts({});

      setCurrentSelectedVariables(
        Object.keys(selectedWeighting["targetPercentages"])
      );
      setTargetPercentages({ ...selectedWeighting.targetPercentages });
      setWeightedCounts(selectedWeighting.weightedCounts || {});
      setWeightingStats({ ...selectedWeighting.stats });
      fetchFrequencyDataForVariables(
        Object.keys(selectedWeighting["targetPercentages"])
      );
    }
  };

  const loadWeighting = (weightingName) => {
    const selectedWeighting = savedWeightings[weightingName];
    if (selectedWeighting) {
      setFrequencyData({});
      setWeightedCounts({});

      setCurrentSelectedVariables(
        Object.keys(selectedWeighting["targetPercentages"])
      );
      setTargetPercentages({ ...selectedWeighting.targetPercentages });
      setWeightedCounts(selectedWeighting.weightedCounts || {});
      setWeightingStats({ ...selectedWeighting.stats });
      setcurrentSelectedVariablesset(Object.keys(selectedWeighting["targetPercentages"]));
      fetchFrequencyDataForVariables(
        Object.keys(selectedWeighting["targetPercentages"])
      );
    }
  };

  const fetchFrequencyDataForVariables = async (variables) => {
    try {
      const response = await axios.post(config.API_BASE_URL + "/wtfrequency", {
        currentSelectedVariablesset: variables,
        projectId: projectId,
        filter: isFilterActive ? filterExpression : null, // Pass filter if active
                user: powner,
        project: JSON.stringify(selectedProject),
        client: JSON.stringify(selectedClient),
      });
      setFrequencyData(response.data);
    } catch (error) {
      console.error("Error fetching frequency data:", error);
    }
  };

  const handleVariableSelectionChange = (event) => {
    const selectedOptions = Array.from(
      event.target.selectedOptions,
      (option) => option.value
    );
    const selectedOptionsset = Array.from(
      event.target.selectedOptions,
      (option) => dataGroup[option.value].varName.map((item) => item.Name)
    ).flat();
    setcurrentSelectedVariablesset(selectedOptionsset);
    setCurrentSelectedVariables(selectedOptions);
  };

  const fetchFrequencyData = async () => {
    try {
      const response = await axios.post(config.API_BASE_URL + "/wtfrequency", {
        variables: currentSelectedVariablesset,
        projectId: projectId,
        filter: isFilterActive ? filterExpression : null, // Pass filter if active
                        user: powner,
        project: JSON.stringify(selectedProject),
        client: JSON.stringify(selectedClient),
      });
      setFrequencyData(response.data);
    } catch (error) {
      console.error("Error fetching frequency data:", error);
    }
  };

  const handleTargetPercentageChange = (variable, value, key) => {
    setTargetPercentages((prev) => ({
      ...prev,
      [variable]: {
        ...prev[variable],
        [key]: value,
      },
    }));
  };

  const applyWeighting = async () => {
    const adjustedTargetDistributions = {};
    Object.entries(frequencyData).forEach(([variable, values]) => {
      const totalFreq = Object.values(values).reduce(
        (sum, val) => sum + val,
        0
      );
      adjustedTargetDistributions[variable] = calculateAdjustedTargets(
        values,
        targetPercentages[variable] || {},
        totalFreq
      );
    });
    
    const weightVariableName = `weight${
      (savedWeightings && Object.keys(savedWeightings).length) || ""
    }`;

    try {
      const response = await axios.post(config.API_BASE_URL + "/applyweights", {
        target_distributions: adjustedTargetDistributions,
        weight_variable_name: weightVariableName,
        projectId: projectId,
        user: powner,
        project: JSON.stringify(selectedProject),
        client: JSON.stringify(selectedClient),
        filter: isFilterActive ? filterExpression : null // Pass filter if active
      });
      setWeightedCounts(response.data.weighted_counts);

      const stats = {
        min: response.data.weight_min,
        max: response.data.weight_max,
        efficiency: response.data.cv,
        newefficiency: response.data.check,
        iterations: response.data.iteration,
        weightingName: weightVariableName,
      };
      setWeightingStats(stats);
      saveCurrentWeighting(
        weightVariableName,
        stats,
        response.data.weighted_counts,
        response.data.targetPercentages
      );
      
      if (isFilterActive) {
        alert(`Weights applied to filtered respondents only. Non-qualified respondents will have blank weights in the SPSS file.`);
      }
    } catch (error) {
      console.error("Error applying weights:", error);
    }
  };

  const handleTargetPercentageBatchUpdate = (updates) => {
    setTargetPercentages((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const handlePaste = (e, startVariable, startKey) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text");
    const entries = paste
      .split(/\r\n|\r|\n/)
      .map((line) => line.trim())
      .filter((line) => line);

    if (!entries.length) {
      console.error("No entries parsed from paste data");
      return;
    }

    const allVariableKeys = getAllVariableKeys(frequencyData);
    const startIndex = allVariableKeys.findIndex(
      (vk) => vk.variable === startVariable && vk.key === startKey
    );

    if (startIndex === -1) {
      console.error("Starting variable/key not found in the current list");
      return;
    }

    let updates = {};
    entries.forEach((value, index) => {
      const targetIndex = startIndex + index;
      if (targetIndex < allVariableKeys.length) {
        const { variable, key } = allVariableKeys[targetIndex];
        const parsedValue = parseValue(value);
        if (!updates[variable]) {
          updates[variable] = {};
        }
        updates[variable][key] = parsedValue;
      }
    });

    handleTargetPercentageBatchUpdate(updates);
  };

  const parseValue = (value) => {
    const numericValue = value.replace(/[^0-9.%]/g, "");
    if (numericValue.includes("%")) {
      return parseFloat(numericValue.replace("%", "")) / 100;
    } else {
      return parseFloat(numericValue) / 100;
    }
  };

  const clearTargetPercentages = () => {
    const resetPercentages = {};
    Object.keys(targetPercentages).forEach((variable) => {
      resetPercentages[variable] = {};
      Object.keys(targetPercentages[variable]).forEach((key) => {
        resetPercentages[variable][key] = "";
      });
    });
    setTargetPercentages(resetPercentages);
  };

  const getAllVariableKeys = (frequencyData) => {
    let allVariableKeys = [];
    Object.entries(frequencyData).forEach(([variable, values]) => {
      Object.keys(values).forEach((key) => {
        allVariableKeys.push({ variable, key });
      });
    });
    return allVariableKeys;
  };

  const calculateAdjustedTargets = (values, targets, totalFreq, variable) => {
    let newTargets = {};
    const keysWithTargets = Object.keys(targets);
    const difference = Object.keys(values).filter(
      (key) => !Object.keys(targets).includes(key)
    );
    const totwithoutNan = Object.entries(values)
      .filter(
        ([key, _]) =>
          key !== "NaN" && !isNaN(Number(key)) && !difference.includes(key)
      )
      .reduce((sum, [_, value]) => sum + value, 0);

    Object.keys(values).forEach((key) => {
      if (key !== "NaN" && !isNaN(Number(key)) && !difference.includes(key)) {
        newTargets[key] = targets[key]
          ? (targets[key] * totwithoutNan) / totalFreq
          : values[key] / totalFreq;
      } else {
        newTargets[key] = values[key] / totalFreq;
      }
    });

    return newTargets;
  };

  const handleDownload = async () => {
    const response = await fetch(
      `${config.API_BASE_URL}/download_weighted_file`
    );
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "weighted.sav");
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const removeVariable = (variable) => {
    setcurrentSelectedVariablesset(
      currentSelectedVariablesset.filter((v) => v !== variable)
    );
    setFrequencyData((prev) => {
      const newFrequencyData = { ...prev };
      delete newFrequencyData[variable];
      return newFrequencyData;
    });
  };

  const goToUploadData = () => {
    navigate("/uploaddata");
  };

  const clearvars = () => {
    setcurrentSelectedVariablesset([]);
    setFrequencyData({});
  };

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const closeModalAndUpdateButtons = () => {
    setIsModalOpen(false);
  };

  const handleSaveCustomVariable = async (customVariable) => {
    try {
      if (!customVariable?.name) {
        throw new Error("Custom variable name is missing");
      }

      setcurrentSelectedVariablesset((prev) => [...prev, customVariable.name]);
      try {
        const response = await axios.post(
          `${config.API_BASE_URL}/compute-newvar`,
          {
            projectId: projectId,
            customVariable: customVariable,
          }
        );

        if (response.data.success) {
          alert(response.data.message);
        }
      } catch (err) {
        console.error("Error creating custom variable:", err);
      } finally {
      }
      alert("Custom variable created successfully!");
    } catch (error) {
      console.error("Error creating custom variable:", error);
      alert(error.message || "Error creating custom variable");
    }
  };

  return (
    <div className="mainw-content">
      {Object.keys(weightingStats).length > 0 && (
        <div className="stats-weightings-container">
          <div className="weighting-stats">
            <div>
              <h3>
                Weighting Statistics - {weightingStats.weightVariableName}
              </h3>
              <p>Minimum Weight: {weightingStats.min}</p>
              <p>Maximum Weight: {weightingStats.max}</p>
              <p>Efficiency (CV): {weightingStats.efficiency}%</p>
              <p>New Efficiency (CV): {weightingStats.newefficiency}%</p>
              <p>Iterations: {weightingStats.iterations}</p>
            </div>
          </div>
          <div className="saved-weightings">
            <h2>Saved Weightings</h2>
            <select
              onChange={(e) => loadWeighting(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>
                Select Saved Weighting
              </option>
              {Object.keys(savedWeightings).map((name, index) => (
                <option key={index} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      {/* Filter Section */}
      <div className="filter-section" style={{
        margin: "20px",
        padding: "15px",
        border: "1px solid #ddd",
        borderRadius: "5px",
        backgroundColor: "#f9f9f9"
      }}>
        <h3>Filter Respondents for Weighting</h3>
        <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
          <div style={{ flex: 1 }}>
            <textarea
              value={filterExpression}
              onChange={(e) => setFilterExpression(e.target.value)}
              placeholder="Enter filter expression (e.g., age > 30 and gender == 'Male')&#10;Leave empty to weight all respondents"
              rows={2}
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "14px",
                fontFamily: "monospace",
                border: "1px solid #ccc",
                borderRadius: "4px"
              }}
            />
            <div style={{ marginTop: "5px", fontSize: "12px", color: "#666" }}>
              <strong>Examples:</strong> age > 30 | gender == 'Male' | income >= 50000
            </div>
          </div>
          <div>
            <button
              onClick={() => {
                setIsFilterActive(!!filterExpression.trim());
                if (filterExpression.trim()) {
                  fetchFrequencyData();
                  alert(`Filter activated. Weights will only be calculated for respondents matching: ${filterExpression}`);
                } else {
                  setIsFilterActive(false);
                  fetchFrequencyData();
                  alert("Filter cleared. Weights will be calculated for all respondents.");
                }
              }}
              style={{
                padding: "8px 16px",
                backgroundColor: filterExpression.trim() ? "#4CAF50" : "#ccc",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: filterExpression.trim() ? "pointer" : "not-allowed"
              }}
              disabled={!filterExpression.trim()}
            >
              Apply Filter
            </button>
            {isFilterActive && (
              <button
                onClick={() => {
                  setFilterExpression("");
                  setIsFilterActive(false);
                  fetchFrequencyData();
                }}
                style={{
                  marginLeft: "10px",
                  padding: "8px 16px",
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}
              >
                Clear Filter
              </button>
            )}
          </div>
        </div>
        {isFilterActive && (
          <div style={{
            marginTop: "10px",
            padding: "8px",
            backgroundColor: "#e8f5e9",
            borderRadius: "4px",
            color: "#2e7d32"
          }}>
            ✓ Filter active: Only respondents matching "{filterExpression}" will receive weights
          </div>
        )}
      </div>

      {loading ? (
        <Loader loading={loading} />
      ) : (
        <div className="frequency-data">
          <button onClick={fetchFrequencyData}>Get Frequency Data</button>
          <button onClick={() => toggleModal()} title="Update Properties">
            Add Variable
          </button>
          <CustomizedVariable
            isOpen={isModalOpen}
            onClose={closeModalAndUpdateButtons}
            setcurrentSelectedVariablesset={setcurrentSelectedVariablesset}
            dataGroup={dataGroup}
            projectId={projectId}
          />
          <button onClick={clearTargetPercentages}>
            Clear Target Percentages
          </button>
          <button onClick={clearvars}>Clear Variable List</button>
          {Object.keys(weightingStats).length > 0 && (
            <>
              <button onClick={handleDownload}>Download Weighted File</button>
              <button onClick={saveCurrentWeightingBackend}>
                Save Current Weighting
              </button>
            </>
          )}
          {targetPercentages &&
            Object.entries(targetPercentages).length > 0 && (
              <button onClick={applyWeighting}>Apply Weighting</button>
            )}
          {frequencyData &&
            currentSelectedVariablesset &&
            Object.entries(frequencyData).length > 0 &&
            currentSelectedVariablesset.length > 0 && (
              <>
                <h2>Selected Variables Frequency Data</h2>
                <table>
                  <thead>
                    <tr>
                      <th>Variable Value</th>
                      <th>Frequency</th>
                      <th>Percentage</th>
                      <th>Target Percentage</th>
                      <th>Adjusted Target Percentage</th>
                      <th>Weighted Count</th>
                      <th>Weighted Percentage</th>
                      <th>Remove Variable</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(frequencyData).map(([variable, values]) => {
                      const totalFreq = Object.values(values).reduce(
                        (sum, val) => sum + val,
                        0
                      );
                      const totalWeightedCount =
                        Object.values(weightedCounts?.[variable] || {}).reduce(
                          (sum, val) => sum + val,
                          0
                        ) || totalFreq;
                      const adjustedTargets = calculateAdjustedTargets(
                        values,
                        targetPercentages[variable] || {},
                        totalFreq,
                        variable
                      );

                      let previousVariable = null;

                      return Object.entries(values).map(
                        ([key, freq], index) => {
                          const freqNum =
                            typeof freq === "number"
                              ? freq
                              : parseFloat(freq) || 0;
                          const percentage =
                            totalFreq > 0 ? (freqNum / totalFreq) * 100 : 0;
                          const numericalKey = Number(key);
                          const keyString = isNaN(numericalKey)
                            ? "NaN"
                            : numericalKey.toFixed(0);

                          const adjustedTarget = adjustedTargets[key]
                            ? adjustedTargets[key] * 100
                            : 0;

                          const weightedCountNum = weightedCounts?.[variable]?.[
                            keyString
                          ]
                            ? typeof weightedCounts[variable][keyString] ===
                              "number"
                              ? weightedCounts[variable][keyString]
                              : parseFloat(
                                  weightedCounts[variable][keyString]
                                ) || freqNum
                            : freqNum;

                          const weightedPercentage =
                            totalWeightedCount > 0
                              ? (weightedCountNum / totalWeightedCount) * 100
                              : 0;

                          const rowClass =
                            previousVariable !== variable ? "dark-border" : "";
                          previousVariable = variable;

                          return (
                            <tr
                              key={`${variable}-${key}-${index}`}
                              className={rowClass}
                            >
                              <td>{`${variable} (${key})`}</td>
                              <td>{freqNum.toFixed(2)}</td>
                              <td>{percentage.toFixed(2)}%</td>
                              <td>
                                <input
                                  type="text"
                                  value={
                                    targetPercentages[variable]?.[key] || ""
                                  }
                                  onChange={(e) =>
                                    handleTargetPercentageChange(
                                      variable,
                                      e.target.value,
                                      key
                                    )
                                  }
                                  onPaste={(e) => handlePaste(e, variable, key)}
                                />
                              </td>
                              <td>{adjustedTarget.toFixed(2)}%</td>
                              <td>{weightedCountNum.toFixed(2)}</td>
                              <td>{weightedPercentage.toFixed(2)}%</td>
                              <td>
                                <button
                                  onClick={() => removeVariable(variable)}
                                  style={{
                                    background: "transparent",
                                    border: "none",
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                                >
                                  &#x2715;
                                </button>
                              </td>
                            </tr>
                          );
                        }
                      );
                    })}
                  </tbody>
                </table>
              </>
            )}
        </div>
      )}
      {JSON.stringify(currentSelectedVariablesset)}
    </div>
  );
}

export default Weighting;